import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { TweenMax } from 'gsap';
import { injectCustomClasses } from '../../Utils/frontEndMutate';
import style from './style.module.scss';

const ButtonPrimary = ({ label, color, background, disabled, type, onClick, size, classes, borderColor }) => {

  let buttonRef = null;

  const handleButtonType = () => {
    const types = {
      neutral: style.neutralButton,
      yellow: style.yellowButton,
      red: style.redButton,
      lightBlue: style.lightBlueButton,
      blue: style.blueButton,
      green: style.greenButton,
      orange: style.orangeButton
    };
    return types[type];
  };

  const customClasses = injectCustomClasses(classes);

  const onMouseEnter = () => {
    TweenMax.to(buttonRef, 0.2, { rotation: 4, scale: 1.1 })
  }

  const onMouseLeave = () => {
    TweenMax.to(buttonRef, 0.2, { rotation: 0, scale: 1.0 })
  }

  return (
    <button
      onMouseEnter={!disabled && onMouseEnter}
      onMouseLeave={!disabled && onMouseLeave}
      disabled={disabled}
      ref={e => buttonRef = e}
      onClick={onClick}
      className={`${handleButtonType()} ${style.buttonPrimary} ${style[size]} ${customClasses}`}
      style={{ background: background ? `${background}` : null, color: color ? `${color}` : null, borderColor: borderColor ? `${borderColor}` : null }}>
      {label ? label : null}
    </button>
  );
};

ButtonPrimary.defaultProps = {
  label: 'Click Me!',
  color: null,
  background: null,
  borderColor: null,
  disabled: false,
  type: 'neutral',
  classes: null,
  onClick: () => {
  },
};

ButtonPrimary.propTypes = {
  onClick: PropTypes.func,
  color: PropTypes.string,
  borderColor: PropTypes.string,
  background: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  classes: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
  ]),
  type: PropTypes.oneOf([
    'neutral',
    'yellow',
    'red',
    'lightBlue',
    'blue'
  ]),
};

export default ButtonPrimary;
